import { NAV_PATH } from '../../lib/nav';
import type { PageRoute } from '../../page-route';
import { AdminAgentDataPage } from './page';

/**
 * «Данные для ИИ-агентов» (005, T139): в оболочке приложения. Пункт меню — только у администратора системы
 * (`lib/nav.ts`); другим ролям сервер отвечает `403`, страница показывает причину.
 */
export const route: PageRoute = { path: NAV_PATH.agentData, access: 'authed', Component: AdminAgentDataPage };
